export default "<app-header [currentUser]=\"currentUser\"></app-header>\n\n<router-outlet></router-outlet>\n\n<notifier-container></notifier-container>\n"